import { SignOutService } from 'types/services';
import { sportingAPI } from '../api';

export const signOut: SignOutService = async () => {
  await sportingAPI.auth.logout();
};
